/**
 * True when the device has any coarse (touch) input. Used to skip programmatic
 * input focus: on touch devices focusing an input pops the on-screen keyboard,
 * which covers the step before the user sees it. `any-pointer` (not `pointer`)
 * so a touch table with a mouse plugged in still counts as touch.
 * Environments without matchMedia (jsdom) report false, keeping the desktop
 * behavior.
 */
export const hasCoarsePointer = (): boolean => (
  typeof window.matchMedia === 'function'
  && window.matchMedia('(any-pointer: coarse)').matches
);

export default hasCoarsePointer;
